module.exports = __webpack_public_path__ + "img/pic-1.7fff9b71.png";